export enum ConfigValueType {
  // eslint-disable-next-line id-blacklist
  String = 'String',
  // eslint-disable-next-line id-blacklist
  Number = 'Number',
  // eslint-disable-next-line id-blacklist
  Boolean = 'Boolean',
  Integer = 'Integer',
}

export type ConfigValue = string | string[] | number | number[] | boolean;

export enum ClientConfigPlatforms {
  WEB = 'WEB',
  MOBILE = 'MOBILE',
  MOBILE_ANDROID = 'MOBILE_ANDROID',
  MOBILE_IOS = 'MOBILE_IOS',
  TABLET = 'TABLET',
  TABLET_ANDROID = 'TABLET_ANDROID',
  TABLET_IOS = 'TABLET_IOS',
  BIGSCREEN = 'BIGSCREEN',
  ANDROID_TV = 'ANDROID_TV',
  APPLE_TV = 'APPLE_TV',
  LG = 'LG',
  HISENSE = 'HISENSE',
  SAMSUNG = 'SAMSUNG',
}

export interface ConfigEntry {
  value: ConfigValue;
  platformId?: string;
  modifiedBy: string;
  modifiedAt: string;
}

export interface Config {
  key: string;
  description: string;
  dataType: ConfigValueType;
  isList: boolean;
  // values: Record<ClientConfigPlatforms, ConfigEntry>;
  values: ConfigEntry[];
}

export interface StreamingConfig {
  key: string;
  description: string;
  dataType: ConfigValueType;
  isList: boolean;
  values: Record<ClientConfigPlatforms, ConfigEntry>;
}

export enum ConfigEditorDetailVariant {
  New = 'New',
  Edit = 'Edit',
}
